export const fonts = {
  default: "'Brandon Grotesque', Arial, Helvetica, sans-serif",
}
